export default __webpack_public_path__ + "static/media/courses.0b4823dc.jpg";